import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Передача до MMS» (/dashboard/owner/comdisp) — РЕДИЗАЙН.
 *
 * У топбар винесено лише добу поставки — головний операційний контрол сторінки
 * (§6 дизайн-контракту). Місяць у блоці «Баланс» лишається в самому блоці: він
 * керує одним віджетом, а не сторінкою, тож у топбарі був би оманливим.
 *
 * Прийом той самий, що useForecastUi / useMarketPricesUi / useTradingUi:
 * модульний state + CustomEvent-синхронізація в межах вкладки.
 */
const EV = 'helios:comdisp-ui-change';

/** Доба поставки за замовчуванням — завтра: графік подається на D+1. */
const tomorrowIso = () => new Date(Date.now() + 864e5).toLocaleDateString('en-CA');

const state = { date: tomorrowIso() as string };

const emit = () => window.dispatchEvent(new CustomEvent(EV));

/** Зсув ISO-дати на ±N діб (UTC — без стрибків на переході часу). */
export function shiftComdispDay(iso: string, delta: number): string {
  if (!iso) return iso;
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + delta);
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
}

export function useComdispUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setDate = useCallback((d: string) => {
    if (d && state.date !== d) { state.date = d; emit(); }
  }, []);

  return { date: state.date, setDate };
}
